import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/blog", label: "Blog" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

function DesktopNav() {
  return (
    <>
      <nav className="hidden md:flex items-center gap-1">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.to === "/"}
            data-testid={`nav-link-${l.label.toLowerCase()}`}
            className={({ isActive }) =>
              `px-4 py-2 text-sm rounded-md transition-colors ${
                isActive
                  ? "text-[hsl(var(--primary))] font-semibold"
                  : "text-foreground/70 hover:text-foreground"
              }`
            }
          >
            {l.label}
          </NavLink>
        ))}
      </nav>
      <div className="hidden md:flex items-center gap-3">
        <Link
          to="/contact"
          data-testid="nav-cta-consultation"
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium bg-[hsl(var(--primary))] text-white hover:bg-[#1A3A31] transition-colors"
        >
          Schedule Consultation
          <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </>
  );
}

function MobileMenu() {
  return (
    <div className="md:hidden border-t border-border bg-[hsl(var(--background))]" data-testid="nav-mobile-panel">
      <div className="container-x py-4 flex flex-col gap-1">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.to === "/"}
            data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
            className={({ isActive }) =>
              `px-3 py-3 rounded-md text-base ${
                isActive ? "bg-secondary text-foreground" : "text-foreground/80"
              }`
            }
          >
            {l.label}
          </NavLink>
        ))}
        <Link
          to="/contact"
          data-testid="mobile-nav-cta"
          className="mt-2 inline-flex items-center justify-center gap-1.5 px-4 py-3 rounded-md text-sm font-medium bg-[hsl(var(--primary))] text-white"
        >
          Schedule Consultation
          <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => { setOpen(false); }, [pathname, setOpen]);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[hsl(var(--background))]/75 border-b border-border/60"
    >
      <div className="container-x flex items-center justify-between h-20 md:h-24">
        <Link to="/" data-testid="nav-logo" aria-label="X-HRverse home" className="flex items-center gap-2 group">
          <img
            src="https://customer-assets.emergentagent.com/job_recruit-hub-201/artifacts/m39dxinf_Dynamic_Tech_Company_Logo_-_X-HRverse-removebg-preview.png"
            alt="X-HRverse"
            className="h-16 md:h-20 w-auto object-contain"
          />
        </Link>
        <DesktopNav />
        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          className="md:hidden p-2 rounded-md border border-border"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>
      {open && <MobileMenu />}
    </header>
  );
}
